import React, { useState, useEffect } from "react";
import { useTenant } from "../../../context/TenantContext";
import umService from "../../../services/university-admin/umService";
import UMExportModal from "./UMExportModal";
import AppButton from "../../../components/ui/AppButton";
import { useTranslation } from "react-i18next";
import { useUniAdminAuth } from "../../../context/UniAdminAuthContext";
import { PERMISSIONS } from "../../../utils/permissionKeys";

const UMGlobalFilterBar = ({ filters, onFilterChange }) => {
  const { userRole, currentTenantId } = useTenant();
  const { t } = useTranslation(["universityManager"]);
  const { can } = useUniAdminAuth();
  const canFilterByClub = can(PERMISSIONS.club.list);
  const [clubs, setClubs] = useState([]);
  const [showExportModal, setShowExportModal] = useState(false);

  useEffect(() => {
    if (!canFilterByClub) return;
    const fetchDropdowns = async () => {
      const clubRes = await umService.getAllClubs({ userRole, currentTenantId });
      if (clubRes.success) setClubs(clubRes.data);
    };
    fetchDropdowns();
  }, [userRole, currentTenantId, canFilterByClub]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ ...filters, [name]: value });
  };

  return (
    <div className="card shadow-sm mb-4 border-0" style={{ borderRadius: '12px' }}>
      <div className="card-body d-flex flex-wrap gap-3 align-items-end">
        <div className="flex-grow-1" style={{ minWidth: '150px' }}>
          <label className="form-label text-muted fw-semibold small mb-1">{t("analytics.filterBar.startDate")}</label>
          <input type="date" className="form-control bg-light border-0" name="startDate" value={filters.startDate} onChange={handleChange} />
        </div>
        <div className="flex-grow-1" style={{ minWidth: '150px' }}>
          <label className="form-label text-muted fw-semibold small mb-1">{t("analytics.filterBar.endDate")}</label>
          <input type="date" className="form-control bg-light border-0" name="endDate" value={filters.endDate} onChange={handleChange} />
        </div>
        {canFilterByClub && (
          <div className="flex-grow-1" style={{ minWidth: '200px' }}>
            <label className="form-label text-muted fw-semibold small mb-1">{t("analytics.filterBar.club")}</label>
            <select className="form-select bg-light border-0" name="clubId" value={filters.clubId} onChange={handleChange}>
              <option value="">{t("analytics.filterBar.allClubs")}</option>
              {clubs.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
        )}
        <div>
          <AppButton variant="primary" className="shadow-sm" onClick={() => setShowExportModal(true)}>
            <i className="fas fa-download me-2"></i> {t("analytics.filterBar.exportReport")}
          </AppButton>
        </div>
      </div>

      {showExportModal && (
        <UMExportModal filters={filters} onClose={() => setShowExportModal(false)} />
      )}
    </div>
  );
};

export default UMGlobalFilterBar;
